/* Malicious Threads · daily games hub: today's pack, shared streak, combined share. */
(function () {
  'use strict';
  var root = document.getElementById('mt-hub'); if (!root || !window.MTG) return;
  var G = window.MTG, $ = function (id) { return document.getElementById(id); };
  var API = root.getAttribute('data-api') || '/apps/ctf/daily', SIGNED_IN = root.getAttribute('data-signed-in') === '1', SHARE_URL = root.getAttribute('data-share');
  var say = G.sayer($('hb-msg'));
  var DEFAULT_MILESTONES = [{ days: 30, points: 100 }, { days: 100, points: 250 }, { days: 365, points: 500 }];
  function setCard(id, done, text, cta) {
    var c = $(id); c.className = 'hb-g' + (done ? ' is-done' : '');
    c.querySelector('.hb-st').textContent = text; c.querySelector('.hb-go').textContent = cta;
  }
  function render(d) {
    $('hb-num').textContent = '#' + d.number;
    G.countdown($('hb-cd'), d.resetsAt, function () { location.reload(); });
    var day = d.day, today, streak;
    if (d.signedIn) {
      today = d.today; streak = { streak: d.streak, best: d.best, todayDone: d.todayDone };
    } else {
      var hs = G.guestHist(d.epoch);
      var pwg = G.load('mt-pwdl-v1'), hpg = G.load('mt-hop-v1'), lhg = G.load('mt-lh-v1');
      var ch = function (h) { return h && h[day] && h[day] !== '.' ? h[day] : null; };
      today = {
        passwordle: ch(hs[0]) ? { done: true, result: ch(hs[0]), easy: !!(pwg.m && pwg.m[day] === 'e') } : { done: false, started: !!(pwg.game && pwg.game.day === day && pwg.game.guesses && pwg.game.guesses.length) },
        hop: ch(hs[1]) ? { done: true, score: ch(hs[1]) === 'a' ? 10 : Number(ch(hs[1])) } : { done: false, started: !!(hpg.game && hpg.game.day === day) },
        loghunt: ch(hs[2]) ? { done: true, result: ch(hs[2]) } : { done: false, started: !!(lhg.game && lhg.game.day === day && lhg.game.st && lhg.game.st.clicks && lhg.game.st.clicks.length) },
      };
      streak = G.streak(hs, day);
    }
    var p = today.passwordle, h = today.hop, l = today.loghunt;
    setCard('hb-pw', p.done, p.done ? (p.result === 'x' ? '✗ locked out' : '✓ cracked in ' + p.result) + (p.easy ? ' (easy)' : '') : p.started ? 'in progress' : 'not played yet', p.done ? '[ SEE RESULT ]' : p.started ? '[ CONTINUE ]' : '[ PLAY ]');
    setCard('hb-hp', h.done, h.done ? '✓ ' + h.score + '/10' : h.started ? 'in progress' : 'not played yet', h.done ? '[ SEE RESULT ]' : h.started ? '[ CONTINUE ]' : '[ PLAY ]');
    setCard('hb-lh', l.done, l.done ? (l.result === 'x' ? '✗ not found' : '✓ found in ' + l.result) + ' · ' + d.loghunt.difficulty : (l.started ? 'in progress · ' : 'today: ') + d.loghunt.difficulty, l.done ? '[ SEE RESULT ]' : l.started ? '[ CONTINUE ]' : '[ PLAY ]');
    var doneCount = [p, h, l].filter(function (x) { return x.done; }).length;
    $('hb-streak').textContent = (streak.streak ? '🔥 ' : '') + streak.streak;
    $('hb-best').textContent = streak.best;
    $('hb-term').textContent = streak.streak ? streak.streak + (streak.streak === 1 ? ' day' : ' days') + ' and counting' + (streak.todayDone ? ' (today done)' : ' (today: ' + doneCount + '/3)') : 'play all three today to start one';
    var ms = (d.milestones && d.milestones.length ? d.milestones : DEFAULT_MILESTONES);
    var earned = d.earned || [];
    var next = ms.filter(function (m) { return streak.streak < m.days; })[0];
    if (!doneCount && !streak.streak) $('hb-goal').textContent = 'Finish all three games today to start a streak.';
    else if (!streak.todayDone) $('hb-goal').textContent = doneCount + ' of 3 done today. Finish the pack to ' + (streak.streak ? 'keep your streak.' : 'start a streak.');
    else $('hb-goal').textContent = "Today's pack is done. Come back tomorrow.";
    if (next) {
      $('hb-bar').style.width = Math.min(100, Math.round(streak.streak / next.days * 100)) + '%';
      $('hb-reward').textContent = streak.streak + ' / ' + next.days + ' days → +' + next.points + ' CTF points' + (SIGNED_IN ? '' : ' (sign in to collect)');
    } else { $('hb-bar').style.width = '100%'; $('hb-reward').textContent = 'Every streak reward collected. Legend.'; }
    if (earned.length) $('hb-reward').textContent += ' · earned: ' + earned.map(function (id) { return id.replace('daily-', '') + ' days'; }).join(', ');
    var btn = $('hb-share'); btn.disabled = doneCount === 0;
    btn.onclick = function () {
      var lines = ['Malicious Threads Daily #' + d.number,
        '🔐 Passwordle ' + (p.done ? (p.result === 'x' ? '❌' : '✅ ' + p.result + (p.result === '1' ? ' guess' : ' guesses')) + (p.easy ? ' (easy)' : '') : '⬜'),
        '📈 Higher or Pwned ' + (h.done ? h.score + '/10' : '⬜'),
        '🔍 Log Hunt ' + (l.done ? (l.result === 'x' ? '❌' : '✅ in ' + l.result) + ' (' + d.loghunt.difficulty + ')' : '⬜')];
      if (streak.streak) lines.push('🔥 ' + streak.streak + '-day streak');
      lines.push(SHARE_URL);
      G.share(btn, lines.join('\n'), btn.parentNode.parentNode, say);
    };
    popup(d, !!streak.todayDone);
  }
  /* Drop-alerts pop-up: once today's pack is done. Never again after signing up; a week's rest after "not now". */
  function popup(d, done) {
    var pop = $('gm-pop'); if (!pop) return;
    var K = 'mt-pop-v1', st = G.load(K), last = null;
    var posted = pop.querySelector('[data-posted]');
    function open() {
      last = document.activeElement; pop.hidden = false;
      var f = pop.querySelector('#gm-pop-email') || pop.querySelector('[data-close]'); if (f) f.focus();
    }
    function close() {
      if (pop.hidden) return;
      if (!st.sub) { st.until = d.number + 7; G.save(K, st); }
      pop.hidden = true; if (last && last.focus) last.focus();
    }
    pop.addEventListener('click', function (e) { if (e.target === pop || e.target.closest('[data-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var form = pop.querySelector('form');
    if (form) form.addEventListener('submit', function () { try { sessionStorage.setItem('mt-pop-sent', '1'); } catch (_) { /* private mode */ } });
    var sent = false;
    try { sent = sessionStorage.getItem('mt-pop-sent') === '1'; sessionStorage.removeItem('mt-pop-sent'); } catch (_) { /* private mode */ }
    if (sent && posted) {
      if (posted.getAttribute('data-posted') === 'ok') { st.sub = true; G.save(K, st); }
      open(); return;
    }
    if (st.sub || !done || (st.until && d.number < st.until)) return;
    setTimeout(open, 900);
  }
  G.api(API).then(function (d) {
    if (!d.ok) { say('The games server is offline right now. Try again shortly.', 'is-bad'); return; }
    render(d);
  });
})();
